import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';

const loadFileAccessComponent = () =>
  import('./files/file-access/file-access.component').then(m => m.FileAccessComponent);

const routes: Routes = [
  {
    path: 'files',
    pathMatch: 'full',
    loadComponent: loadFileAccessComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'files/:name',
    loadComponent: loadFileAccessComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'download',
    loadChildren: () => import('./download/download.module').then(m => m.DownloadModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
